import { FC } from 'react';

import { Formik, type FormikHelpers } from 'formik';
import SimpleCompanyForm from 'modules/account/contact/forms/SimpleCompanyForm';
import {
  SIMPLE_COMPANY_FORM,
  SIMPLE_COMPANY_SCHEMA,
} from 'modules/account/contact/forms/schema';
import { useCreateCompany } from 'modules/account/contact/hooks';

import { ComponentToRenderGenericProps } from '../GlobalCreate';

const FORM_INIT = {
  name: '',
  industry: '',
  type: '',
} as SIMPLE_COMPANY_FORM;

type CompanyProps = ComponentToRenderGenericProps;

const Company: FC<CompanyProps> = ({ close }) => {
  const { mutate: addCompany } = useCreateCompany(true);

  const onSubmit = (
    values: SIMPLE_COMPANY_FORM,
    { setSubmitting }: FormikHelpers<SIMPLE_COMPANY_FORM>,
  ) => {
    addCompany(values as SIMPLE_COMPANY_FORM, {
      onSuccess: () => {
        close();
      },
      onSettled: () => {
        setSubmitting(false);
      },
    });
  };

  return (
    <Formik
      initialValues={FORM_INIT}
      onSubmit={onSubmit}
      validationSchema={SIMPLE_COMPANY_SCHEMA}
    >
      {() => <SimpleCompanyForm onCancel={close} />}
    </Formik>
  );
};

export default Company;
